import React from 'react';
import { StyledBundlePrice } from './style';
import { PMBundlePriceProps } from 'utils/types';
import { Box } from '@mui/material';

export const WhispersBundlePrice: React.FC<PMBundlePriceProps> = ({
  prices,
  bundleButtonColor,
  bundleButtonTextColor = 'white',
}) => {
  return (
    <StyledBundlePrice
      bundleButtonColor={bundleButtonColor}
      bundleButtonTextColor={bundleButtonTextColor}
    >
      <Box className="whispers__price-button totalPrice">
        <span className="actual-price">{prices.priceDisplay}</span>
      </Box>
    </StyledBundlePrice>
  );
};
